<template>
    <div v-loading="loading">
        <div style="display: flex;justify-content: space-between;margin-bottom: 10px;padding: 0 10px">
            <b style="line-height: 28px">{{ title }}
                <!-- 批量操作按钮 - 替代原来的下载和复制按钮 -->
                <el-tooltip v-if="!isBatchMode" content="批量操作" placement="top">
                    <el-button type="primary" size="small" style="margin-left: 10px" @click="enterBatchMode">
                        <el-icon><Operation /></el-icon> 批量操作
                    </el-button>
                </el-tooltip>
            </b>
        </div>
        
        <!-- 批量操作模式下的顶部选择按钮 -->
        <div v-if="isBatchMode" style="margin-bottom: 10px;padding: 0 10px;">
            <el-button-group>
                <el-button size="small" @click="selectCurrentPage(true)">当前页全选</el-button>
                <el-button size="small" @click="selectCurrentPage(false)">当前页取消</el-button>
                <el-button size="small" @click="selectAllPages(true)">跨页全选</el-button>
                <el-button size="small" @click="selectAllPages(false)">跨页取消</el-button>
            </el-button-group>
            <span style="margin-left: 10px;">已选择: {{ selectedCount }} 项</span>
        </div>
        
        <slot name="header"></slot>
        <el-table :data="data" :id="id" ref="table" :border="border" :style="{width}" @sort-change="sortChange"
                  :height="height" :show-summary="showSummary" :span-method="spanMethod" :cell-style="cellStyle"
                  :summary-method="summaryMethod" :row-class-name="rowClassName" :default-sort="defaultSort"
                  @selection-change="handleSelectionChange"
                  :header-cell-style="isBatchMode ? {cursor: 'pointer'} : {}"
                  :row-key="row => row[imageIdField]">
            <!-- row-key用于跨页保存选中状态 -->
            <!-- 批量操作模式下添加选择列 -->
            <el-table-column v-if="isBatchMode" type="selection" width="55" fixed="left" :reserve-selection="true" />
            <slot></slot>
        </el-table>
        <el-table :data="complete || data" id="complete" ref="complete_table" :border="border" :style="{width}"
                  @sort-change="sortChange" :show-summary="showSummary" :span-method="spanMethod"
                  :cell-style="cellStyle" :summary-method="summaryMethod" :row-class-name="rowClassName"
                  :default-sort="defaultSort" v-show="false"
                  :row-key="row => row[imageIdField]">
            <!-- row-key用于跨页保存选中状态 -->
            <template v-for="node in $slots.default()">
                <component :is="node" v-if="node.props && node.props['download-hide']===undefined"></component>
            </template>
        </el-table>
        
        <!-- 批量操作模式下的底部操作按钮 -->
        <div v-if="isBatchMode" style="display: flex;justify-content: flex-end;margin-top: 10px;padding: 0 10px">
            <el-button size="small" @click="downloadSelectedTable" :loading="downloadingTable">
                <el-icon><Download /></el-icon> 下载表格
            </el-button>
            <el-button size="small" type="primary" @click="downloadSelectedImages" :loading="downloadingImages" style="margin-left: 10px">
                <el-icon><PictureFilled /></el-icon> 下载原图
            </el-button>
            <el-button size="small" @click="copySelectedTable" :loading="copyingTable" style="margin-left: 10px">
                <el-icon><DocumentCopy /></el-icon> 复制表格
            </el-button>
            <el-button size="small" @click="exitBatchMode" style="margin-left: 10px">
                <el-icon><Close /></el-icon> 取消
            </el-button>
        </div>
    </div>
</template>

<script>
import { copyTable } from '../libs/utils';
import {downloadResourcesAsZip} from '../libs/downloadUtils';
import {Operation, Download, DocumentCopy, PictureFilled, Close} from '@element-plus/icons-vue';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import axios from "ts-axios-new";

export default {
    name: "DownloadableTable",
    components: {
        Operation,
        Download,
        DocumentCopy,
        PictureFilled,
        Close
    },
    props: {
        id: {
            type: String,
            default: 'table',
        },
        title: String,
        data: Array,
        loading: Boolean,
        tips: String,
        border: Boolean,
        showSummary: Boolean,
        spanMethod: Function,
        cellStyle: Object,
        summaryMethod: Function,
        rowClassName: String,
        defaultSort: Function,
        width: String,
        complete: Array,
        height: [String, Number],
        // 新增属性：用于标识资源字段名称和图片ID字段名称
        resourceField: {
            type: String,
            default: 'resource'
        },
        imageIdField: {
            type: String,
            default: 'image_id'
        }
    },
    data() {
        return {
            // 批量操作状态
            isBatchMode: false,
            selected: [],
            // 用于跨页保存选中项的Map，key为唯一标识符，value为选中状态
            selectedMap: new Map(),
            // 加载状态
            downloadingTable: false,
            downloadingImages: false,
            copyingTable: false,
            columns: [],
            downloading: false,
            // 分类数据
            category_list: [],
            category_map: {},
        }
    },
    computed: {
        // 计算当前选中的数量
        selectedCount() {
            return this.selectedMap.size;
        }
    },
    mounted() {
        // 获取分类数据
        this.getCategories();
    },
    methods: {
        // 获取分类数据
        getCategories() {
            axios.get('/cms/v1/category').then(res => {
                // 过滤掉特殊分类，与其他组件保持一致
                this.category_list = res.data.data.categoryList.filter(c => !['ALL', 'COLLECTION'].includes(c.key));
                // 构建分类key到中文名称的映射
                this.category_map = {};
                this.category_list.forEach(category => {
                    this.category_map[category.key] = category.i18n_name.ZH_HANS;
                });
            }).catch(error => {
                console.error('获取分类数据失败:', error);
            });
        },
        // 进入批量操作模式
        enterBatchMode() {
            this.isBatchMode = true;
            // 不默认全选，让用户手动选择
        },
        
        // 退出批量操作模式
        exitBatchMode() {
            this.isBatchMode = false;
            this.selected = [];
            this.selectedMap.clear();
            // 清除表格选择
            if (this.$refs.table) {
                this.$refs.table.clearSelection();
            }
        },
        
        // 处理表格选择变化
        handleSelectionChange(selection) {
            this.selected = selection;
            
            // 清空并重新填充selectedMap，确保与表格选择状态一致
            this.selectedMap.clear();
            
            // 遍历当前选中的项，添加到Map中
            selection.forEach((item) => {
                // 使用image_id或其他唯一标识符作为key
                const key = item[this.imageIdField] || JSON.stringify(item);
                this.selectedMap.set(key, item);
            });
        },
        
        // 选择/取消选择当前页
        selectCurrentPage(select = true) {
            if (!this.$refs.table) return;
            
            this.data.forEach(row => {
                if (select) {
                    this.$refs.table.toggleRowSelection(row, true);
                } else {
                    this.$refs.table.toggleRowSelection(row, false);
                }
            });
        },
        
        // 选择/取消选择所有页
        selectAllPages(select = true) {
            if (select) {
                // 全选所有数据（包括完整数据）
                const allData = this.complete || this.data;
                allData.forEach(item => {
                    const key = item[this.imageIdField] || JSON.stringify(item);
                    this.selectedMap.set(key, item);
                });
                
                this.$nextTick(() => {
                    if (this.$refs.table) {
                        const dataToSelect = this.complete || this.data;
                        dataToSelect.forEach(row => {
                            this.$refs.table.toggleRowSelection(row, true);
                        });
                    }
                });
            } else {
                // 取消所有选择
                this.selectedMap.clear();
                if (this.$refs.table) {
                    this.$refs.table.clearSelection();
                }
            }
        },
        
        // 下载选中的表格
        downloadSelectedTable() {
            if (this.selectedMap.size === 0) {
                this.$message.warning('请先选择要下载的项');
                return;
            }
            
            this.downloadingTable = true;
            try {
                // 获取选中的数据
                const selectedData = Array.from(this.selectedMap.values());
                
                // 创建临时表格用于获取列信息
                const tableInstance = this.$refs.table;
                
                // 如果有表格实例，尝试从表格中获取列信息
                if (tableInstance && tableInstance.columns) {
                    // 递归获取所有可见列（包括子列）
                    const getAllVisibleColumns = (columns) => {
                        let result = [];
                        columns.forEach(col => {
                            // 跳过选择列
                            if (col.type && col.type === 'selection') {
                                return;
                            }
                            // 如果有子列，递归处理
                            if (col.children && col.children.length > 0) {
                                result = [...result, ...getAllVisibleColumns(col.children)];
                            } else {
                                // 普通列，直接添加
                                result.push(col);
                            }
                        });
                        return result;
                    };
                    
                    // 获取所有可见列
                    const visibleColumns = getAllVisibleColumns(tableInstance.columns);
                    
                    // 准备导出的数据
                    console.log('visibleColumns', visibleColumns)
                    console.log('selectedData', selectedData)
                    
                    // 构建列标签映射：使用列的label属性
                    const columnLabels = {};
                    visibleColumns.forEach((col, index) => {
                        const prop = col.property;
                        if (prop) {
                            // 尝试多种方式获取label
                            let label = col.label || 
                                       col.columnConfig?.label ||
                                       col.columnConfig?.prop ||
                                       (col.columnConfig && typeof col.columnConfig === 'object' ? Object.values(col.columnConfig).find(v => typeof v === 'string' && v.length > 0) : null) ||
                                       prop;
                            columnLabels[prop] = label;
                            // 调试信息
                            if (index === 0) {
                                console.log('First column object:', col);
                                console.log('col.label:', col.label);
                                console.log('col.columnConfig:', col.columnConfig);
                            }
                        }
                    });
                    
                    console.log('columnLabels:', columnLabels);
                    console.log('First export row keys:', exportData.length > 0 ? Object.keys(exportData[0]) : 'no data');
                    
                    const exportData = selectedData.map((row) => {
                        const exportRow = {};
                        
                        visibleColumns.forEach((col, index) => {
                            const prop = col.property;
                            if (prop && row.hasOwnProperty(prop)) {
                                // 使用从DOM获取的表头文本或列配置中的label
                                const label = columnLabels[prop] || col.label || prop;
                                let value = row[prop];
                                // 分类key翻译：检查是否为分类字段并进行翻译
                                // 1. 单个分类key的情况
                                if (prop.toLowerCase().includes('category') && !Array.isArray(value) && this.category_map[value]) {
                                    value = this.category_map[value];
                                }
                                // 2. 分类key数组的情况（字段名为categories）
                                if (prop === 'categories' && Array.isArray(value)) {
                                    value = value
                                        .map(key => this.category_map[key] || key)
                                        .join(', ');
                                }
                                // 3. 其他可能的分类数组字段
                                if (Array.isArray(value) && value.every(key => typeof key === 'string' || typeof key === 'number') && 
                                    prop.toLowerCase().includes('category')) {
                                    value = value
                                        .map(key => this.category_map[key] || key)
                                        .join(', ');
                                }
                                // 百分比字段格式化（添加%符号）
                                if (prop.includes('_rate_') && (typeof value === 'number' || value === null)) {
                                    value = value !== null ? value + '%' : '';
                                }
                                // 布尔值字段格式化
                                if (prop === 'video') {
                                    value = value ? '是' : '否';
                                }
                                if (prop === 'animation') {
                                    value = value ? '是' : '';
                                }
                                exportRow[label] = value;
                            }
                        });
                        return exportRow;
                    });
                    
                    console.log('exportData sample:', exportData[0]);
                    
                    // 使用xlsx库生成Excel文件
                    const wb = XLSX.utils.book_new();
                    const ws = XLSX.utils.json_to_sheet(exportData);
                    
                    // 调整列宽
                    const colWidths = visibleColumns.map((col) => ({
                        wch: 15 // 默认列宽
                    }));
                    ws['!cols'] = colWidths;
                    
                    XLSX.utils.book_append_sheet(wb, ws, this.title || 'Sheet1');
                    
                    const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: false, type: 'array' });
                    const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    
                    saveAs(blob, `${this.title || 'table'}.xlsx`);
                } else {
                    // 如果无法获取表格列信息，使用原始数据直接导出
                    const wb = XLSX.utils.book_new();
                    const ws = XLSX.utils.json_to_sheet(selectedData);
                    
                    XLSX.utils.book_append_sheet(wb, ws, this.title || 'Sheet1');
                    
                    const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: false, type: 'array' });
                    const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    
                    saveAs(blob, `${this.title || 'table'}.xlsx`);
                }
                
                this.$message.success('表格下载成功');
                this.downloadingTable = false;
            } catch (error) {
                console.error('下载表格失败:', error);
                this.$message.error('下载表格失败');
                this.downloadingTable = false;
            }
        },
        
        // 下载选中的图片
        async downloadSelectedImages() {
            if (this.selectedMap.size === 0) {
                this.$message.warning('请先选择要下载的项');
                return;
            }
            
            this.downloadingImages = true;
            try {
                // 直接使用完整的选中数据，确保data.json包含所有字段
                const resources = Array.from(this.selectedMap.values())
                    .filter(item => item[this.resourceField]); // 过滤出有资源的项
                
                if (resources.length === 0) {
                    this.$message.warning('没有可下载的图片资源');
                    this.downloadingImages = false;
                    return;
                }
                
                // 使用downloadResourcesAsZip进行下载，传递CDN URL作为baseUrl
                await downloadResourcesAsZip(resources, `${this.title || 'images'}-${new Date().getTime()}.zip`, {
                    baseUrl: import.meta.env.VITE_CDN_URL
                });
                this.$message.success('图片下载成功');
            } catch (error) {
                console.error('下载图片失败:', error);
                this.$message.error('下载图片失败');
            } finally {
                this.downloadingImages = false;
            }
        },
        
        // 复制选中的表格到剪贴板
        copySelectedTable() {
            if (this.selectedMap.size === 0) {
                this.$message.warning('请先选择要复制的项');
                return;
            }
            
            this.copyingTable = true;
            try {
                // 获取选中的数据
                const selectedData = Array.from(this.selectedMap.values());
                
                // 创建临时表格用于复制
                const tempTable = document.createElement('table');
                tempTable.style.width = '100%';
                tempTable.border = this.border ? '1' : '0';
                
                // 获取表格列信息
                const tableInstance = this.$refs.table;
                let visibleColumns = [];
                let columnLabels = {};
                
                // 如果有表格实例，尝试从表格中获取列信息
                if (tableInstance && tableInstance.columns) {
                    // 递归获取所有可见列（包括子列）
                    const getAllVisibleColumns = (columns) => {
                        let result = [];
                        columns.forEach(col => {
                            // 跳过选择列
                            if (col.type && col.type === 'selection') {
                                return;
                            }
                            // 如果有子列，递归处理
                            if (col.children && col.children.length > 0) {
                                result = [...result, ...getAllVisibleColumns(col.children)];
                            } else {
                                // 普通列，直接添加
                                result.push(col);
                            }
                        });
                        return result;
                    };
                    
                    // 获取所有可见列
                    visibleColumns = getAllVisibleColumns(tableInstance.columns);
                    
                    // 构建列标签映射：使用列的label属性
                    visibleColumns.forEach((col) => {
                        const prop = col.property;
                        if (prop) {
                            // 优先使用列的label属性
                            let label = col.label || 
                                       (col.columnConfig && col.columnConfig.label) ||
                                       prop;
                            columnLabels[prop] = label;
                        }
                    });
                } else {
                    // 如果无法获取表格列信息，使用选中数据的键作为列
                    if (selectedData.length > 0) {
                        visibleColumns = Object.keys(selectedData[0]).map(key => ({
                            property: key,
                            label: key
                        }));
                        visibleColumns.forEach((col) => {
                            columnLabels[col.property] = col.label;
                        });
                    }
                }
                
                // 创建表头
                const thead = document.createElement('thead');
                const headerRow = document.createElement('tr');
                visibleColumns.forEach((col) => {
                    const th = document.createElement('th');
                    const prop = col.property;
                    const label = columnLabels[prop] || col.label || prop || '';
                    th.textContent = label;
                    headerRow.appendChild(th);
                });
                thead.appendChild(headerRow);
                tempTable.appendChild(thead);
                
                // 创建表体
                const tbody = document.createElement('tbody');
                selectedData.forEach((row) => {
                    const tr = document.createElement('tr');
                    visibleColumns.forEach((col) => {
                        const td = document.createElement('td');
                        const prop = col.property;
                        if (prop && row.hasOwnProperty(prop)) {
                            let value = row[prop];
                            // 分类key翻译：检查是否为分类字段并进行翻译
                            // 1. 单个分类key的情况
                            if (prop.toLowerCase().includes('category') && !Array.isArray(value) && this.category_map[value]) {
                                value = this.category_map[value];
                            }
                            // 2. 分类key数组的情况（字段名为categories）
                            if (prop === 'categories' && Array.isArray(value)) {
                                value = value
                                    .map(key => this.category_map[key] || key)
                                    .join(', ');
                            }
                            // 3. 其他可能的分类数组字段
                            if (Array.isArray(value) && value.every(key => typeof key === 'string' || typeof key === 'number') && 
                                prop.toLowerCase().includes('category')) {
                                value = value
                                    .map(key => this.category_map[key] || key)
                                    .join(', ');
                            }
                            // 百分比字段格式化（添加%符号）
                            if (prop.includes('_rate_') && (typeof value === 'number' || value === null)) {
                                value = value !== null ? value + '%' : '';
                            }
                            // 布尔值字段格式化
                            if (prop === 'video') {
                                value = value ? '是' : '否';
                            }
                            if (prop === 'animation') {
                                value = value ? '是' : '';
                            }
                            td.textContent = String(value);
                        }
                        tr.appendChild(td);
                    });
                    tbody.appendChild(tr);
                });
                tempTable.appendChild(tbody);
                
                // 将临时表格添加到DOM中
                document.body.appendChild(tempTable);
                
                // 执行复制
                copyTable(tempTable);
                
                // 复制完成后移除临时表格
                document.body.removeChild(tempTable);
                
                this.$message.success('表格已复制到剪贴板');
                this.copyingTable = false;
            } catch (error) {
                console.error('复制表格失败:', error);
                this.$message.error('复制表格失败');
                this.copyingTable = false;
            }
        },
        
        sort(prop, order) {
            this.$refs.table.sort(prop, order)
        },
        sortChange({column, prop, order}) {
            this.$emit('sort-change', {column, prop, order})
        },
    },
}
</script>

<style scoped>
@keyframes rotating {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
